import script from "./GameRules.vue?vue&type=script&setup=true&lang=js"
export * from "./GameRules.vue?vue&type=script&setup=true&lang=js"

import "./GameRules.vue?vue&type=style&index=0&id=1898e61f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1898e61f"]])

export default __exports__